<template>
  <div class="transfer">
    <t-list
      ref="left"
      :data="leftData"
      :title="titles && titles[0] ? titles[0] : 'items'"
      :filterable="filterable"
      :show-footer="showFooter"
      :filter-placeholder="filterPlaceholderState"
      :filter-method="filterMethod"
      :not-found-text="notFoundTextState"
      :size="size"
      :checked-key="leftCheckedKeys"
      :render-content="renderContent"
      direction="left">
      <slot name="left-footer"></slot>
    </t-list>
    <t-operation ref="operation" :operations="operations" :size="size">
    </t-operation>
    <t-list
      ref="right"
      :data="rightData"
      :title="titles && titles[1] ? titles[1] : 'items'"
      :filterable="filterable"
      :show-footer="showFooter"
      :filter-placeholder="filterPlaceholderState"
      :filter-method="filterMethod"
      :not-found-text="notFoundTextState"
      :size="size"
      :checked-key="rightCheckedKeys"
      :render-content="renderContent"
      direction="right">
      <slot name="right-footer"></slot>
    </t-list>
  </div>
</template>
<script>
import TList from './list.vue'
import TOperation from './operation.vue'
import { t } from '../../locale'

export default {
  name: 'TTransfer',
  components: { TList, TOperation },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    targetKeys: {
      type: Array,
      default() {
        return []
      }
    },
    selectedKeys: {
      type: Array,
      default() {
        return []
      }
    },
    titles: {
      type: Array,
      default() {
        return [' items', ' items']
      }
    },
    operations: {
      type: Array,
      default() {
        return []
      }
    },
    filterable: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    filterPlaceholder: {
      type: String,
      default: ''
    },
    filterMethod: {
      type: Function,
      default(data, query) {
        if (data) {
          const type = 'label' in data ? 'label' : 'key'
          return (data[type] + '').indexOf(query) > -1
        } else {
          return false
        }
      }
    },
    notFoundText: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      validator(value) {
        return ['', 'sm'].includes(value)
      }
    },
    renderContent: Function
  },
  data() {
    return {
      leftData: [],
      rightData: [],
      leftCheckedKeys: [],
      rightCheckedKeys: [],
      tKeys: this.targetKeys.length ? this.targetKeys : []
    }
  },
  computed: {
    filterPlaceholderState() {
      return this.filterPlaceholder || t('t.transfer.filterPlaceholder')
    },
    notFoundTextState() {
      return this.notFoundText || t('t.transfer.notFoundText')
    }
  },
  watch: {
    data(newVal) {
      if (!newVal || !newVal.length || newVal.length === 0) {
        this.tKeys = []
      }
      this.$_splitData(false)
    },
    targetKeys(newVal) {
      this.tKeys = newVal.length ? newVal : []
      this.$_splitData(false)
    },
    selectedKeys(newVal) {
      this.$_splitSelectedKey(newVal)
    }
  },
  created: function() {
    this.$_splitData(true)
  },
  methods: {
    $_splitData(init = false) {
      this.leftData = [...this.data]
      this.rightData = []
      if (this.tKeys.length > 0) {
        this.leftData = this.leftData.filter((data, index) => {
          if (this.tKeys.includes(data.key)) {
            this.rightData.push(data)
            return false
          } else {
            return true
          }
        })
      }
      if (init) {
        this.$_splitSelectedKey()
      }
    },
    $_splitSelectedKey(selectedKeys = this.selectedKeys) {
      if (selectedKeys.length > 0) {
        let [_leftCheck, _rightCheck] = [[], []]
        for (let data of this.leftData) {
          if (selectedKeys.includes(data.key)) {
            _leftCheck.push(data.key)
          }
        }
        this.leftCheckedKeys = [..._leftCheck]
        for (let data of this.rightData) {
          if (selectedKeys.includes(data.key)) {
            _rightCheck.push(data.key)
          }
        }
        this.rightCheckedKeys = [..._rightCheck]
      }
    },
    moveTo(direction) {
      let targetKeys = this.tKeys
      let opposite = direction === 'left' ? 'right' : 'left'
      const moveKeys = this.$refs[opposite].checkedKeys
      const newTargetKeys =
        direction === 'right'
          ? moveKeys.concat(targetKeys)
          : targetKeys.filter(targetKey => !moveKeys.some(checkedKey => targetKey === checkedKey))
      this.tKeys = newTargetKeys
      this.$_splitData()
      this.$refs[opposite].checkAll(false)
      this.$emit('on-change', newTargetKeys, direction, moveKeys)
    },
    handleCheckedKeysChange(direction, keys) {
      this[`${direction}CheckedKeys`] = keys
    }
  }
}
</script>



// WEBPACK FOOTER //
// transfer.vue?16a98649